import { autoinject } from 'aurelia-dependency-injection';
import { CustomerSettings } from '../classes/customer-settings';
import { CustomerViewModel } from '@dynamik/common/clients/transaction-clients';
import { CustomersCache } from './customers-cache';

@autoinject
export class TransactionCustomerCache {
  constructor(private customersCache: CustomersCache, private customerSettings: CustomerSettings) { }

  customer: Promise<CustomerViewModel>;
  companyIdentityId: number;

  async get() {
    const all = await this.customersCache.get();
    return all.find(c => c.companyId === this.customerSettings.selectedCustomer.companyId);
  }
}
